import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { c, h } from '@debbie/cortex/dist/index.js';
import { Checkbox, Input, Select } from '../..//index.js';
import FilterGroup from '../FilterGroup.js';
import FilterOption from '../FilterOption.js';
import CaseGroupSearch from '../../search/CaseGroupSearch.js';
import { Entity } from '@debbie/common/dist/index.js';
import { usePropertyTypes } from '@debbie/cortex/dist/properties/index.js';
import { debounce } from '@debbie/common/dist/util/index.js';
const PropertiesGroup = (props) => {
    const lang = useSelector((s) => s.lang);
    const { caseFilter } = props;
    const [caseGroup, setCaseGroup] = useState(props.caseFilter.property?.scopeId ?? null);
    const [ref, setRef] = useState(props.caseFilter.property?.referenceType ?? Entity.Case);
    const [handle, setHandle] = useState(props.caseFilter.property?.handle ?? '');
    const [value, setValue] = useState(props.caseFilter.property?.value ?? '');
    const [commaSeparated, setCommaSeparated] = useState(props.caseFilter.property?.commaSeparated ?? true);
    const propertyTypesLoader = usePropertyTypes();
    const propertyTypes = h.hasData(propertyTypesLoader)
        ? propertyTypesLoader.data.filter((propertyType) => {
            const scoped = caseGroup
                ? propertyType.scopeId === caseGroup || !propertyType.scopeId
                : true;
            const _ref = propertyType.ref === ref;
            return scoped && _ref;
        })
        : [];
    const setFilter = (prop) => {
        const property = caseGroup != null && ref != null && handle != '' && value != ''
            ? {
                scope: 'case_groups',
                scopeId: caseGroup,
                referenceType: ref,
                handle: handle,
                value: value,
                commaSeparated: commaSeparated,
                ...prop,
            }
            : undefined;
        if (property &&
            property.value != '' &&
            property.handle != '' &&
            property.scopeId != null &&
            property.referenceType != null) {
            c.insights.updateFilter({ ...caseFilter, property });
        }
        else {
            c.insights.clearFilter('property');
        }
    };
    return (React.createElement(FilterGroup, { name: lang.caseFilter.properties },
        React.createElement(FilterOption, { active: !!caseFilter.property, header: lang.caseFilter.property, subheader: lang.caseFilter.propertyExplanation, onDeactivate: () => c.insights.clearFilter('property') },
            React.createElement(Select, { value: ref, onChange: (e) => {
                    setRef(e.currentTarget.value);
                    setFilter({ referenceType: e.currentTarget.value });
                } },
                React.createElement("option", { value: Entity.Case }, lang.properties.cases),
                React.createElement("option", { value: Entity.CaseVoucher }, lang.properties.caseVouchers)),
            React.createElement(CaseGroupSearch, { onSelect: (group) => {
                    setCaseGroup(group);
                    setFilter({ scopeId: group ?? undefined });
                }, selected: caseGroup }),
            caseGroup != null && (React.createElement(Select, { value: handle, onChange: (e) => {
                    setHandle(e.currentTarget.value);
                    setFilter({ handle: e.currentTarget.value });
                } },
                React.createElement("option", { value: '' }, ''),
                propertyTypes.map((property) => {
                    return (React.createElement("option", { key: `${property.tenantId}-${property.scopeId}-${property.handle}`, value: property.handle }, property.label));
                }))),
            caseGroup != null && handle != '' && (React.createElement(React.Fragment, null,
                React.createElement(Input, { placeholder: lang.misc.value, value: value, onChange: (e) => {
                        let val = e.currentTarget.value;
                        setValue(val);
                        debounce('properties-filter-search', () => setFilter({ value: val }), 750);
                    } }),
                React.createElement(Checkbox, { checked: commaSeparated, onChange: (e) => {
                        setCommaSeparated(e.currentTarget.checked);
                        setFilter({ commaSeparated: e.currentTarget.checked });
                    }, placeholder: 'Komma separerede værdier' })))),
        React.createElement(React.Fragment, null)));
};
export default PropertiesGroup;
//# sourceMappingURL=PropertiesGroup.js.map